import {
  addQueryParamToUrl,
  createUrlWithSourceQueryParams,
} from '@crehana/utils';

// Shared "Continue course" navigation — used by the course row click
// (CourseCardRevamp) and the "+" menu's default action (Option), so both
// entry points carry the exact same tracking metadata.
export const navigateToCourse = (lastVideoLectureUrl: string): void => {
  window.location.href = addQueryParamToUrl({
    url: createUrlWithSourceQueryParams({
      url: lastVideoLectureUrl,
      source: 'Learn Dashboard',
      sourceDetail: 'B2B Tracks',
    }),
    key: 'Enrollment Origin',
    value: 'B2B Tracks',
  });
};
